<template>
  <div>
    <div class="tab-pane fade show active" id="stockB" role="tabpanel" aria-labelledby="stockB-tab">
      <div class="stockSetting">
        <p>内容を入力して保存してください。（<span class="hissu">*</span>印は必須項目です。）</p>
        <p class="blue">{{ message }}</p>
        <ValidationObserver ref="observer" tag="form">
          <table class="table">
            <tbody>
              <tr>
                <td class="w200">個体識別コード</td>
                <td>
                  <ValidationProvider v-slot="{ errors }" rules="numeric|min_value:1|max_value:127">
                    <input id="print_individualCodeNumber" type="text" :name="itemName.individualCode"
                      class="print form-control dataInput2" autocomplete="off"
                      v-model="entity.individualCodeNumber" :readonly="isReadonly('individualCodeNumber')" /> 番目
                    <br><span class="errMsg" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <td class=" w200">商品コード<span class="hissu">*</span></td>
                <td>
                  <ValidationProvider v-slot="{ errors }" rules="required|numeric|min_value:1|max_value:127">
                    <input id="print_goodsCodeNumber" type="text" :name="itemName.goodsCode"
                      class="print must form-control dataInput2" autocomplete="off"
                      v-model="entity.goodsCodeNumber" :readonly="isReadonly('goodsCodeNumber')" /> 番目
                    <br><span class="errMsg" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <td>商品名<span class="hissu">*</span></td>
                <td>
                  <ValidationProvider v-slot="{ errors }" rules="required|numeric|min_value:1|max_value:127">
                    <input id="print_goodsNameNumber" type="text" :name="itemName.goodsName"
                      class="print must form-control dataInput2" autocomplete="off"
                      v-model="entity.goodsNameNumber" :readonly="isReadonly('goodsNameNumber')" /> 番目
                    <br><span class="errMsg" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <td>数量</td>
                <td>
                  <ValidationProvider v-slot="{ errors }" rules="numeric|min_value:1|max_value:127">
                    <input id="print_quantityNumber" type="text" :name="itemName.quantity"
                      class="print form-control dataInput2" autocomplete="off"
                      v-model="entity.quantityNumber" :readonly="isReadonly('quantityNumber')" /> 番目
                    <br><span class="errMsg" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <td>JANコード</td>
                <td>
                  <ValidationProvider v-slot="{ errors }" rules="numeric|min_value:1|max_value:127">
                    <input id="print_janCodeNumber" type="text" :name="itemName.janCode"
                      class="print form-control dataInput2" autocomplete="off"
                      v-model="entity.janCodeNumber" :readonly="isReadonly('janCodeNumber')" /> 番目
                    <br><span class="errMsg" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <td>汎用項目</td>
                <td>
                  <ValidationProvider v-slot="{ errors }" rules="numeric|min_value:1|max_value:127">
                    <input id="print_generalItemNumber1" type="text" :name="itemName.generalItem"
                      class="print form-control dataInput2" autocomplete="off"
                      v-model="entity.generalItem1Number" :readonly="isReadonly('generalItem1Number')" /> 番目
                    <br><span class="errMsg" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <td>ヘッダレコード有無<span class="hissu">*</span></td>
                <td>
                  <input id="radio02" type="radio" name="printHeaderExist" :value="1"
                    v-model="entity.headerExist" :disabled="isReadonly('headerExist')" />
                  <label for="radio02" class="mr20">無し</label>
                  <input id="radio03" type="radio" name="printHeaderExist" :value="0"
                    v-model="entity.headerExist" :disabled="isReadonly('headerExist')" />
                  <label for="radio03" class="mr20">有り</label>
                </td>
              </tr>
            </tbody>
          </table>
        </ValidationObserver>
        <button id="savePrintBtn" class="btn btn-lg btn-primary w200" style="margin-top:0;"
          :class="this.permissionData.saveBtn[this.$session.get('userDiv')]" @click="save">
          保存
        </button>
      </div><!-- /.stockSetting -->
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'stock-data-set-print-num-table',

  components: {
    ValidationObserver,
    ValidationProvider
  },

  data () {
    return {
      permissionData: {},
      entity: {
        individualCodeNumber: '',
        goodsCodeNumber: '',
        goodsNameNumber: '',
        quantityNumber: '',
        janCodeNumber: '',
        generalItem1Number: '',
        generalItem2Number: '',
        installmentTimeNumber: '',
        headerExist: 1
      },
      itemName: {},
      mode: 'entry',
      message: null
    }
  },
  watch: {
    entity: {
      handler: function () {
        this.$emit('setCsvNumber', this.entity)
      },
      deep: true
    }
  },
  async created () {
    this.$emit('setMessage', null, false)
    this.permissionData = this.permission().stockDataSet['entry']
    this.itemName = this.item()
    // 印刷元CSV取込設定（取得）API
    var response = await this.axios.post('/api/csv/print/get', {}, {
      headers: {
        'Authorization': this.$session.get('accessToken'),
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Origin': '*'
      }
    })
    if (response.data) {
      this.mode = 'update'
      this.entity = response.data
      for (var key in this.entity) {
        if (key === 'headerExist') {
          continue
        }

        if (this.entity[key] === 0) {
          this.entity[key] = ''
        }
      }
    }
  },

  methods: {
    isReadonly (item) {
      return this.permissionData[item][this.$session.get('userDiv')] === 'readonly'
    },
    async save () {
      this.$emit('setMessage', null, false)
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        return
      }

      // 印刷元CSV取込設定（取得）API
      await this.axios.post('/api/csv/print/' + this.mode, this.entity, {
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      }).then((response) => {
        this.$emit('setMessage', '保存処理が完了しました。', false)
        this.mode = 'update'
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/StockDataSetPrintNumTable.vue